
import mutations from './mutations'
import state from './state'
import actions from './actions'

import images from './category-images'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  modules: {
    images
  },
}